<div class="col-12 agent-report-player-detail">
<div class="card mb-3">
<div class="card-header d-flex flex-row justify-content-between align-items-center">
    <h2 class="card-title mb-0">Player Winloss — {{ gameLabel() }}</h2>
    <button class="btn btn-outline-secondary btn-sm" (click)="back()">&larr; Back to Company Agent Report</button>
</div>
<div class="card-body">
    <div class="text-muted">
        Report Date:
        <span class="fw-bolder">{{ from || '—' }}</span> to <span class="fw-bolder">{{ to || '—' }}</span>
    </div>
</div>
</div>

<div class="card" *ngIf="is_loading">
    <div class="card-body text-center text-muted">Loading…</div>
</div>

<div class="card" *ngIf="!is_loading">
    <div class="card-body">
        <div class="table-responsive agent-report-player-detail-scroll">
        <table class="table table-bordered agent-report-player-detail-table">
            <thead class="table-dark">
                <tr>
                    <th>Player ID</th>
                    <th class="text-end">Total Bet</th>
                    <th class="text-end">Total Wins</th>
                    <th class="text-end">Player</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let p of players">
                    <td>
                        {{ p.player_code || ('#' + p.player_id) }}
                        <span class="text-muted small" *ngIf="p.player_name"> — {{ p.player_name }}</span>
                    </td>
                    <td class="text-end">{{ p.bet | number:'1.2-2' }}</td>
                    <td class="text-end">{{ p.winloss | number:'1.2-2' }}</td>
                    <td class="text-end">{{ p.player * -1 | number:'1.2-2' }}</td>
                </tr>
                <tr *ngIf="players.length === 0">
                    <td colspan="4" class="text-center">No data found</td>
                </tr>
            </tbody>
            <tfoot class="table-dark" *ngIf="players.length > 0">
                <tr>
                    <td>Total</td>
                    <td class="text-end">{{ sum('bet') | number:'1.2-2' }}</td>
                    <td class="text-end">{{ sum('winloss') | number:'1.2-2' }}</td>
                    <td class="text-end fw-bolder">{{ sum('player') * -1 | number:'1.2-2' }}</td>
                </tr>
            </tfoot>
        </table>
        </div>
    </div>
</div>
</div>
